import Amplify, { Storage } from 'aws-amplify';

/** @see https://docs.amplify.aws/lib/auth/start/q/platform/js#re-use-existing-authentication-resource */
const initAmplify = () => {
  Amplify.configure({
    Auth: {
      identityPoolId: process.env.REACT_APP_AMAZON_IDENTITY_POOL_ID,
      region: process.env.REACT_APP_AMAZON_REGION,
      userPoolId: process.env.REACT_APP_AMAZON_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_AMAZON_USER_POOL_WEB_CLIENT_ID,
      oauth: {
        domain: process.env.REACT_APP_AMAZON_OAUTH_DOMAIN,
        scope: ['email', 'profile', 'openid'],
        redirectSignIn: `${window.location.origin}/login-callback`,
        redirectSignOut: `${window.location.origin}/logout`,
        responseType: 'code',
      },
    },
    Storage: {
      AWSS3: {
        bucket: process.env.REACT_APP_AMAZON_BUCKET,
        region: process.env.REACT_APP_AMAZON_REGION,
      },
      customPrefix: {
        public: '',
      },
    },
  });
  Storage.configure({ level: 'public' });
};

export default initAmplify;
